export default __webpack_public_path__ + "locales/lo-LA/MainBar.json?hash=7ecac906387a2946a50d2902de73dfcb";